import { useSelector } from 'react-redux';

export function useResourceMetrics(resourceType, id) {
  const metrics = useSelector((state: any) => state.metrics);
  const sourceMetrics = metrics?.[resourceType]?.[id];
  return sourceMetrics?.fileStats || {};
}
